import { FilteredAgenciesDocument } from '../../graphql/graphql';

export const filteredAgenciesQuery = FilteredAgenciesDocument;
